// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gVNTt73{color:#99999b}a.IQRZkJN{font-weight:600}.gVNTt73,a.IQRZkJN{font-size:12px;line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"policyNotice": `gVNTt73`,
	"policyNoticeLink": `IQRZkJN`
};
export default ___CSS_LOADER_EXPORT___;
